import { isMobile } from 'react-device-detect';

import CONF from 'config/conf.singleton';
import ENV from 'config/env.conf';
import { DEPLOYMENT, NODE } from 'constants/env.const';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';

// NOTE: due to how import is handled, CONF may be undefined at start

export const isEnvProdOnly = (conf) => DEPLOYMENT.prod === (conf ?? CONF)?.environment;

export const isEnvProd = (conf) => {
  // treat beta the same as prod since they already operate on the same DB
  const env = (conf ?? CONF)?.environment;
  return DEPLOYMENT.prod === env || DEPLOYMENT.beta === env;
};

export const isEnvNotProd = (conf) => {
  // should work the same as isEnvProd() and just return negation of the same result
  const env = (conf ?? CONF)?.environment;
  return DEPLOYMENT.prod !== env && DEPLOYMENT.beta !== env;
};

export const isEnvBeta = (conf) => DEPLOYMENT.beta === (conf ?? CONF)?.environment;
export const isEnvStage = (conf) => DEPLOYMENT.stage === (conf ?? CONF)?.environment;
export const isEnvQA = (conf) => DEPLOYMENT.qa === (conf ?? CONF)?.environment;
export const isEnvLab = (conf) => DEPLOYMENT.lab === (conf ?? CONF)?.environment;
export const isEnvDev = (conf) => DEPLOYMENT.dev === (conf ?? CONF)?.environment;

export const isEnvCy = ($) => fromAnyToBool(($?.win ?? window)?.Cypress);
export const isEnvJest = ($) => fromAnyToBool(($?.env ?? ENV)?.JEST_WORKER_ID);
export const isEnvTest = ($) => NODE.test === ($?.env ?? ENV)?.NODE_ENV || isEnvJest($) || isEnvCy($);

export const isEnvMobile = ($) => ($?.regex ? /iPhone|iPad|iPod/i.test($.userAgent ?? navigator.userAgent) : isMobile);
